import React from 'react';
import cn from 'classnames';

import TimeOffSplashStartFreeTrial from 'components/hr/timeOffSplash/TimeOffSplashStartFreeTrial.component';
import UpgradePlanButton from 'components/hr/timeOffSplash/UpgradePlanButton.component';
import S from 'constants/string.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import C from 'utils/values/constant.util';

import CN from './TimeOffSplashPlanBenefitsPanel.module.scss';

const DATA_BENEFITS = C([
  'Client tags',
  '500 marketing texts per month',
  `Unlimited ${S.quoteOpen}Digital Appointment Cards${S.quoteClose}`,
  'Time-off categories and tracking for staff usage',
  'Split payments for self-employed',
]);

const DATA_FEATURE_BENEFITS = C([
  'Staff Targets',
  'Customisable staff permissions',
  `Staff ${S.quoteOpen}view my reports only${S.quoteClose}`,
  'Staff pay calculator',
  'Business profit calculator',
]);

const TimeOffSplashPlanBenefitsPanel = ({ variant, showTrialButton }) => {
  const componentClasses = cn({ [CN.topLabel]: true, [CN[`${variant}Variant`]]: variant });
  return (
    <div data-bem="TimeOffSplashPlanBenefitsPanel" className={CN.card}>
      <div data-bem="TimeOffSplashPlanBenefitsPanel__label" className={CN.cardBanner}>
        <span className={componentClasses} role="img" aria-labelledby="Winner">
          {S.trophy} Advanced plan benefits
        </span>
      </div>

      {DATA_BENEFITS.map((text) => (
        <div className={CN.listItem} key={text}>
          {text}
        </div>
      ))}

      <span className={CN.miniBanner} role="img" aria-labelledby="Coming Soon">
        {S.megaphone} Coming Soon:
      </span>

      {DATA_FEATURE_BENEFITS.map((text) => (
        <div className={CN.listItem} key={text}>
          {text}
        </div>
      ))}

      <div data-bem="TimeOffSplashPlanBenefitsPanel__buttonContainer" className={CN.buttonContainer}>
        <UpgradePlanButton text="UPGRADE PLAN" />
        {fromAnyToBool(showTrialButton) && <TimeOffSplashStartFreeTrial />}
      </div>
    </div>
  );
};

export default TimeOffSplashPlanBenefitsPanel;
